import { CheckAuthorizeStatusAsync, CheckSubscriptionStatusAsync } from "../authService";
import store from "@/store";


//For Applicants
export async function getVacancyApplicantsAsync(jobId, page){
    const url = `${process.env.VUE_APP_API_URL}Applicants/All/${jobId}/?pageNumber=${page}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    
    let checkSubscriptionResponse = response.clone();
    let checkAuthorizeStatusResponse = response.clone();

    await CheckSubscriptionStatusAsync(checkSubscriptionResponse)
    await CheckAuthorizeStatusAsync(checkAuthorizeStatusResponse);
    return response.json();

}

export async function searchJobApplicantsAsync(body, page){
    const url = `${process.env.VUE_APP_API_URL}Applicants/SearchApplicants?pageNumber=${page}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: JSON.stringify(body)
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}



//For Shortlisted

export async function getJobShortlistAsync(jobId, page){
    const url = `${process.env.VUE_APP_API_URL}Applicants/Shortlist/${jobId}?pageNumber=${page}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });

    let checkSubscriptionResponse = response.clone();
    let checkAuthorizeStatusResponse = response.clone();

    await CheckSubscriptionStatusAsync(checkSubscriptionResponse)
    await CheckAuthorizeStatusAsync(checkAuthorizeStatusResponse);
    return response.json();
}

export async function searchJobShortlistAsync(body, page){
    const url = `${process.env.VUE_APP_API_URL}Applicants/SearchShortlist?pageNumber=${page}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: JSON.stringify(body)
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}

//Toggles

export async function toggleApplicantShortlistAsync(body){
    const url = `${process.env.VUE_APP_API_URL}Applicants/ToggleShortlist`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: JSON.stringify(body)
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}

export async function toggleIsCalledAsync(body){
    const url = `${process.env.VUE_APP_API_URL}Applicants/ToggleCalled`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: JSON.stringify(body)
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}

export async function toggleIsInterviewedAsync(body){
    const url = `${process.env.VUE_APP_API_URL}Applicants/ToggleInterviewed`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: JSON.stringify(body)
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}

export async function toggleHasPassedAsync(body){
    const url = `${process.env.VUE_APP_API_URL}Applicants/TogglePassed`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: JSON.stringify(body)
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}

export async function deleteApplicantAsync(body){
    const url = `${process.env.VUE_APP_API_URL}Applicants/DeleteApplicant`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: JSON.stringify(body)
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}


export async function deleteAllApplicantsAsync(jobId){
    const url = `${process.env.VUE_APP_API_URL}Applicants/DeleteAllApplicants/${jobId}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}

export async function deleteAllShortlistedAsync(jobId){
    const url = `${process.env.VUE_APP_API_URL}Applicants/DeleteAllShortlisted/${jobId}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}

